// src/services/baseService.js
import request from "../utils/request";
import qs from "qs";

const baseService = {
  async autocomplete(entity, params, navigate = null) {
    // 1. Garantir que pegamos apenas os filtros, evitando poluir com page/sort
    let rawFilters = { ...params.filters };

    let filters = {};

    // Se não houver arquivo de filtro específico, processamos o rawFilters
    Object.keys(rawFilters).forEach((key) => {
      const value = rawFilters[key];
      if (value !== undefined && value !== null && value !== "") {
        // Se já for um objeto de operador ou $or, mantém
        if (typeof value === "object" && !Array.isArray(value)) {
          filters[key] = value;
        } else if (key === "$or") {
          filters[key] = value;
        } else {
          filters[key] = { $contains: value };
        }
      }
    });

    // Montar o queryObject final usando os valores originais de params para o controle
    const queryObject = {
      filters: filters,
      page: params.page,
      perPage: params.perPage,
      sort: params.sort,
    };

    // Limpeza final de undefined
    Object.keys(queryObject).forEach(
      (key) => queryObject[key] === undefined && delete queryObject[key],
    );

    const query = qs.stringify(queryObject, {
      encode: true,
      arrayFormat: "indices",
      skipNulls: false,
      strictNullHandling: true,
      encodeValuesOnly: true,
    });

    return request("get", `/a/${entity}?${query}`, {}, navigate);
  },

  async get(url, data, headers = {}, entity = null, navigate = null) {
    const queryParams = {
      filters: data.filters || {},
      page: data.page,
      perPage: data.perPage,
      sort: data.sort ?? null,
      ...(data?.view !== undefined && { view: data.view }),
      ...(data?.lean !== undefined && { lean: data.lean }),
      ...(data?.volume_ids !== undefined && { volume_ids: data.volume_ids }),
      // * Parâmetros avulsos de endpoints que recebem filtros próprios na
      // * query string (ex.: etiqueta individual por equipamento).
      ...(data?.number !== undefined && { number: data.number }),
    };

    // Essas deleções são um pouco arriscadas se 'data' vem diretamente
    // da URL ou de um estado que não deveria ter page/perPage/sort dentro de filters.
    // O qs.stringify lida com a estrutura, então talvez não sejam necessárias.
    // Vou mantê-las por agora, mas tenha em mente se ocorrerem efeitos colaterais.
    delete queryParams.filters.page;
    delete queryParams.filters.perPage;
    delete queryParams.filters.sort;

    const queryString = qs.stringify(queryParams, {
      encode: true,
      arrayFormat: "indices",
      skipNulls: false,
      addQueryPrefix: false,
      strictNullHandling: true,
      encodeValuesOnly: true,
    });

    const finalUrl = `${url}${queryString ? "?" + queryString : ""}`;
    console.log("baseService.get: URL final para o backend:", finalUrl);
    return request("get", finalUrl, { headers }, navigate);
  },

  async getByColumn(url, navigate = null) {
    return request("get", `${url}`, {}, navigate);
  },

  async post(url, data, navigate = null, options = {}) {
    return request("post", `${url}`, data, navigate, options);
  },

  async put(url, data, navigate = null) {
    return request("put", `${url}`, data, navigate);
  },

  async delete(url, config = {}, navigate = null) {
    // Garante que pegamos os params de dentro do config
    const params = config.params || {};

    const queryString = qs.stringify(params, {
      encode: true,
      skipNulls: true,
      addQueryPrefix: true, // Adiciona o '?'
      strictNullHandling: true,
      encodeValuesOnly: true,
    });

    const finalUrl = `${url}${queryString}`;

    return request("delete", finalUrl, {}, navigate);
  },

  async deleteWithParams(url, params = {}, headers = {}, navigate = null) {
    const queryString = qs.stringify(params, {
      encode: true,
      skipNulls: true,
      addQueryPrefix: true,
      strictNullHandling: true,
      encodeValuesOnly: true,
    });
    const finalUrl = `${url}${queryString}`;
    return request("delete", finalUrl, { headers }, navigate);
  },
};

export default baseService;
